/* eslint-disable */ import { attachSingleReferenceComponent, referenceComponent } from '@salsita-ai/platform-project-sdk/domain';
import { attachComponent } from '../implementation.js';
import { DeckItem } from '../model/index.js';
export const projectedEntityComponents = [
    attachSingleReferenceComponent(attachComponent.withComponent(referenceComponent, 'ProjectedEntity.$deckItem', true).withAlias('ProjectedEntity'), DeckItem, 'deckItemId')
];

//# sourceMappingURL=projected-entity.js.map